export default __webpack_public_path__ + "static/media/AdFlights_04.6e3291d8.png";